import React, { useState, useEffect } from 'react'
import ConfirmButton from '../../Components/Buttons/ConfirmButton'
import CancelButton from '../../Components/Buttons/CancelButton'
import { getClass, getClassCategories } from '../../Helper'
import Modal from '../../Components/Modal/Modal'
import ButtonContainer from '../../Components/CheckableButton/ButtonContainer'
import CheckableButton from '../../Components/CheckableButton/CheckableButton'
import './CanDeliver.css'
// import uuid from "uuid/v4";

import './model_style.css'

import { createUserObject } from '../Profile/profile.utils'
import FilterAccordion from '../../Components/SearchTeacherFilter/CollapseFilter2'

function CanDeliverForm(props) {
  const is_elt = props.user.is_elt === undefined || props.user.is_elt
  const is_vet = props.user.is_vet

  const { qualifications, selectedData, selectedByQualificationObj, selectedCanDelivers } = props

  let userObject = createUserObject(props.user, true)
  const [user_can_deliver, setcan_deliver] = useState({ ...userObject })
  const [is_checked, set_is_checked] = useState(is_elt ? 'ge' : 'bsb')
  const [levels, setVETLevel] = useState([])
  const [selectedList, setSelectedList] = useState(selectedCanDelivers)
  const [selectedByQualification, setSelectedByQualification] = useState(selectedByQualificationObj)

  const class_types_full = getClass()
  const category_options = getClassCategories()


  useEffect(() => {
    // get all level of VET
    let levels = []
    let levelPriorities = []
    qualifications.filter(item => item.type === 'vet').forEach((item => {
      const subQualifications = item.qualifications
      subQualifications.forEach(ele => {
        if (!levels.includes(ele.level) && ele.level?.length) {
          levels.push(ele.level)
          levelPriorities.push({
            name: ele.level,
            priority: ele.priority
          })
        }
        else if(levels.includes(ele.level) && ele.level?.length && ele.priority) {
          const itemIndex = levelPriorities.findIndex(item => item.name === ele.level)
          levelPriorities = [
            ...levelPriorities.slice(0, itemIndex),
            {
            name: ele.level,
            priority: ele.priority
            },
            ...levelPriorities.slice(itemIndex + 1)
          ]
        }
      })
    }))

    levels.sort((a, b) => {
      const priorityA = levelPriorities.find(item => item.name === a)?.priority || 0;
      const priorityB = levelPriorities.find(item => item.name === b)?.priority || 0;
      return priorityA - priorityB;
    })

    setVETLevel(levels)
  }, [])

  useEffect(() => {
    userObject = createUserObject(props.user, true)
    setcan_deliver({ ...userObject })
  }, [props.user])

  const setCategory = (e) => {
    set_is_checked(e.target.id)
  }

  const selectAll = (category) => {
    let newSelectedClasses = { ...user_can_deliver }
    class_types_full
      .filter((cl) => cl.type.includes(category))
      .forEach((class_type) => {
        if (!newSelectedClasses[category].includes(class_type.key)) {
          newSelectedClasses[category].push(class_type.key)
        }
      })

    setcan_deliver(newSelectedClasses)
  }

  const selectClass = (e) => {
    const classType = e.target.id
    const selectedClass = class_types_full.find((cl) => cl.key === classType)
    let newSelectedClasses = { ...user_can_deliver }

    selectedClass.type.forEach((cat) => {
      if (e.target.checked) {
        if (!newSelectedClasses[cat].includes(classType)) {
          newSelectedClasses[cat].push(classType)
        }
        if (classType === 'All ELICOS') {
          selectAll('ge')
        }
      } else {
        newSelectedClasses[cat] = newSelectedClasses[cat].filter(
          (cl) => cl !== classType
        )
      }
    })
    setcan_deliver(newSelectedClasses)
  }

  const handleLevelChange = (e, qua, rootID) => {
    let currentList = selectedList
    let selectedByQualificationNew = {
      ...selectedByQualification
    }

		if (e.target.checked) {
      currentList.push(e.target.value)
      if(e.target.value !== rootID) {
        currentList = currentList.filter(lv => lv !== rootID);
        if(qua?._id) {
          if(selectedByQualificationNew[qua._id]) {
            selectedByQualificationNew[qua._id] = [
              ...selectedByQualificationNew[qua._id],
              e.target.value
            ]?.filter(ele => ele !== rootID)
          }
          else {
            selectedByQualificationNew[qua._id] = [e.target.value]
          }
        }
      }
      else {
        if(qua?._id) {
          if(selectedByQualificationNew?.[qua._id]) {
            currentList = currentList.filter(lv => !selectedByQualificationNew?.[qua._id]?.includes(lv))
          }
          selectedByQualificationNew[qua._id] = [e.target.value]
        }
      }
      setSelectedList(currentList)
		} else {
			// const splitValue = e.target.value.split("_id:")?.[0]
			// setSelectedList(selectedList.filter(item => item !== e.target.value && item !== splitValue))
      // const splitValue = e.target.value.split("_id:")?.[0]
      currentList = currentList.filter(lv => lv !== e.target.value);
      if(qua?._id && selectedByQualificationNew?.[qua._id]) {
        selectedByQualificationNew[qua._id] = selectedByQualificationNew[qua._id].filter(lv => lv !== e.target.value)
      }
      setSelectedList(currentList) 
		}
    setSelectedByQualification(selectedByQualificationNew)
	}

  return (
    <>
      <Modal
        show={props.show}
        onClose={props.onClose}
        className='model-for-addform custom-for-addCanDeliver'
        header={'Add/Remove ' + (props.type || 'Can Deliver')}
      >
        <div className="mb-2">
          <em>Can't find a course you are qualified to deliver? Email us at <a href="mailto:helpdesk@readyteacher.com.au">helpdesk@readyteacher.com.au</a> to add it here</em>
        </div>
        <div className='main-content-select'>
          {qualifications?.length && levels?.length && <FilterAccordion 
            qualificationList={qualifications}
            levels={levels}
            selectedList={selectedList}
            onChangeCategory={(e, qua, rootID) => handleLevelChange(e, qua, rootID)}
            showTwoColumns
            includeTeacherCategory
          />}
        </div>

        <div className='row qualification-footer mt-5'>
          <div className='col-md-6 buttons'>
            <CancelButton onClick={props.onClose}>Cancel</CancelButton>
          </div>
          <div className='col-md-6 buttons'>
            <ConfirmButton
              onClick={() => {
                props.onSubmit(selectedList)
              }}
            >
              Submit
            </ConfirmButton>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default CanDeliverForm
